import {
  HiEnvelope,
  HiOutlineBanknotes,
  HiOutlineBuildingLibrary,
  HiOutlineDocumentText,
  HiOutlineQuestionMarkCircle,
  HiOutlineShieldCheck,
  HiSquares2X2,
} from "react-icons/hi2";
import { Link } from "react-router-dom";

import classes from "./Footer.module.css";
import approvedby1 from "../../images/validation1.png";
import approvedby2 from "../../images/validation2.png";
import { bankName, email, address } from "../../util/config";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className={classes.footer}>
      <div className={classes.grid}>
        <div className={classes.brand}>
          <Link to="/" className={classes.brandLink}>
            <HiOutlineBuildingLibrary
              className={classes.brandIcon}
              aria-hidden
            />
            {bankName}
          </Link>
          <p className={classes.tagline}>
            Relationship-led banking, lending, and protection—with clarity you
            can build on.
          </p>
        </div>

        <div className={classes.col}>
          <h3 className={classes.colTitle}>
            <HiSquares2X2 className={classes.colTitleIcon} aria-hidden />
            Services
          </h3>
          <nav className={classes.nav} aria-label="Services">
            <Link to="/banking" className={classes.footerLink}>
              <HiOutlineBuildingLibrary
                className={classes.footerLinkIcon}
                aria-hidden
              />
              Banking
            </Link>
            <Link to="/borrowing" className={classes.footerLink}>
              <HiOutlineBanknotes className={classes.footerLinkIcon} aria-hidden />
              Borrowing
            </Link>
            <Link to="/insurance" className={classes.footerLink}>
              <HiOutlineShieldCheck
                className={classes.footerLinkIcon}
                aria-hidden
              />
              Insurance
            </Link>
            <Link to="/help" className={classes.footerLink}>
              <HiOutlineQuestionMarkCircle
                className={classes.footerLinkIcon}
                aria-hidden
              />
              Help
            </Link>
          </nav>
        </div>

        <div className={classes.col}>
          <h3 className={classes.colTitle}>
            <HiEnvelope className={classes.colTitleIcon} aria-hidden />
            Contact
          </h3>
          <a className={classes.mail} href={`mailto:${email}`}>
            <HiEnvelope className={classes.mailIcon} aria-hidden />
            {email}
          </a>
          <address className={classes.address}>
            {address}
          </address>
        </div>

        <div className={classes.col}>
          <h3 className={classes.colTitle}>
            <HiOutlineDocumentText
              className={classes.colTitleIcon}
              aria-hidden
            />
            Legal
          </h3>
          <nav className={classes.nav} aria-label="Legal">
            <Link to="/privacy" className={classes.footerLink}>
              <HiOutlineShieldCheck
                className={classes.footerLinkIcon}
                aria-hidden
              />
              Privacy Policy
            </Link>
            <Link to="/terms" className={classes.footerLink}>
              <HiOutlineDocumentText
                className={classes.footerLinkIcon}
                aria-hidden
              />
              Terms &amp; Conditions
            </Link>
          </nav>
        </div>
      </div>

      <div className={classes.badges}>
        <img src={approvedby1} alt="FSCS protection" />
        <img src={approvedby2} alt="BSI standards" />
      </div>

      <div className={classes.disclosure}>
        <p>
          {bankName} is authorised and regulated by the Swiss Financial Market
          Supervisory Authority (FINMA).
        </p>
        <p>
          {bankName} Insurance Services and {bankName} Investment Solutions are
          each authorised and regulated by FINMA.
        </p>
      </div>

      <p className={classes.copyright}>
        © {year} {bankName}. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
